interface DropdownIconProps {
    strokeColor?: string;
    [key: string]: any;
}

const DropdownIcon = ({ strokeColor, ...props }: DropdownIconProps): JSX.Element =>
(
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {strokeColor && <path
            d="M13 5.5L8 10.5L3 5.5"
            stroke={strokeColor}
            strokeWidth={1.7}
            strokeLinecap="round"
            strokeLinejoin="round"
        />}
    </svg>
);
export default DropdownIcon;
